<template>
    <div>
        <div class="py-2 rounded-lg white black--text elevation-12" block v-if="!item.carChargeData && !item.chargerHistory && PaymentStatus.isReturned(item.status)">
            🤖 Pagamento não associado a um carregamento, foi devolvido.
        </div>

        <div v-for="alert in alerts" :key="alert.key" :class="['py-1 my-1 rounded-lg white--text', alert.critical ? 'critical' : 'warning']">
            <v-icon small left color="white">{{ alert.critical ? "error" : "warning" }}</v-icon>{{ alert.text }}
        </div>
        <div :class="`py-2 rounded-lg ${carChargeData.color} ${carChargeData.secondColor}--text`" block v-if="carChargeData && carChargeData.status != null">
            <v-row class="my-0 py-0">
                <v-col cols="12" lg="4" class="my-0 py-0">
                    <v-icon left :color="carChargeData.secondColor">{{ carChargeData.icon }}</v-icon>
                    {{ carChargeData.status }} {{ carChargeData.errorSession ? "(Aguardando 'StopTransaction')" : "" }}
                </v-col>
                <v-col cols="12" lg="8" class="my-0 py-0">
                    <strong class="ml-2" v-if="carChargeData.percent > 0">
                        {{ carChargeData.percentStart ? `${carChargeData.percentStart}~` : "" }}{{ carChargeData.percent ? carChargeData.percent : "" }}%
                    </strong>
                    <strong class="ml-2">
                        {{ carChargeData.consumption ? Number.parseFloat(carChargeData.consumption).toFixed(2) : 0 }} kWh
                    </strong>
                    <strong class="ml-2">
                        R$ {{ getPrice(carChargeData.consumption) }}
                    </strong>
                </v-col>
            </v-row>
        </div>

        <div :class="`py-2 rounded-lg ${chargerHistory.color} ${chargerHistory.secondColor}--text`" v-if="chargerHistory && chargerHistory.status != null">
            <v-row class="my-0 py-0">
                <v-col cols="12" lg="4" class="my-0 py-0">
                    <v-icon left :color="chargerHistory.secondColor">{{ chargerHistory.icon }}</v-icon>
                    {{ chargerHistory.status }}
                </v-col>
                <v-col cols="12" lg="8" class="my-0 py-0">
                    <strong class="ml-2" v-if="chargerHistory.percent > 0">
                        {{ chargerHistory.percentStart ? `${chargerHistory.percentStart}~` : "" }}{{ chargerHistory.percent ? chargerHistory.percent : "" }}%
                    </strong>
                    <strong class="ml-2">
                        {{ chargerHistory.consumption ? Number.parseFloat(chargerHistory.consumption).toFixed(2) : 0 }} kWh
                    </strong>
                    <strong class="ml-2">
                        R$ {{ getPrice(chargerHistory.consumption) }}
                    </strong>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import HistoryStatus from "@/enum/HistoryStatus";
import PaymentStatus from "@/enum/PaymentStatus";
import statusCharger from "@/helpers/StatusCharger";
import { paymentAlerts } from "@/helpers/paymentAlerts";


export default {
    props: {
        item: {
            type: Object,
        },
    },

    data() {
        return {
            PaymentStatus,
            statusCharger,
        };
    },

    computed: {
        alerts() {
            return paymentAlerts(this.item);
        },
        carChargeData() {
            let ret = { status: null, color: null, secondColor: null, icon: null, consumption: null };

            if (this.item.carChargeData) {
                if (this.item.carChargeData.charger.data.online == 1) {
                    ret = this.statusCharger.getComponentStyle(this.item.carChargeData.status);
                } else {
                    ret = { status: "Offline", color: "grey", secondColor: "white", icon: "cloud_off" };
                }
                ret.consumption = this.item.carChargeData.consumption;
                ret.percentStart = this.item.carChargeData.percentStart ? this.item.carChargeData.percentStart : null;
                ret.percent = this.item.carChargeData.percent ? this.item.carChargeData.percent : null;
            }
            return ret;
        },
        chargerHistory() {
            let ret = { status: null, color: null, secondColor: null, icon: null, consumption: null };
            if (this.item.chargerHistory) {
                if (this.item.chargerHistory.status == HistoryStatus.PROCESSED) {
                    ret.status = "Processado";
                    ret.color = "success";
                    ret.icon = "done_outline";
                    ret.secondColor = "white";
                } else if (this.item.chargerHistory.status == HistoryStatus.NEED_PROCESS && this.item.chargerHistory.counter < 2) {
                    ret.status = "Aguardando processamento";
                    if (this.item.chargerHistory.counter == null) {
                        ret.color = "success";
                        ret.icon = "pending";
                        ret.secondColor = "white";
                    } else {
                        ret.color = "warning";
                        ret.icon = "warning";
                        ret.secondColor = "white";
                    }
                } else if (this.item.chargerHistory.status == HistoryStatus.NEED_PROCESS) {
                    ret.status = "Necessária ação do operador";
                    ret.color = "critical";
                    ret.icon = "error_outline";
                    ret.secondColor = "white";
                } else if (this.item.chargerHistory.status == HistoryStatus.PROCESSED_MANUAL) {
                    ret.status = "Processado manualmente.";
                    ret.color = "white";
                    ret.icon = "warning";
                    ret.secondColor = "success";
                } else if (this.item.chargerHistory.status == HistoryStatus.PROCESSED_MANUAL_ERROR) {
                    ret.status = "Necessário validação com a plataforma oficial do operador";
                    ret.color = "error";
                    ret.icon = "warning";
                    ret.secondColor = "white";
                }
                ret.consumption = this.item.chargerHistory.consumption;
                ret.percentStart = this.item.chargerHistory.car && this.item.chargerHistory.car.percentStart ? this.item.chargerHistory.car.percentStart : null;
                ret.percent = this.item.chargerHistory.car && this.item.chargerHistory.car.percent ? this.item.chargerHistory.car.percent : null;
            }
            return ret;
        }
    },

    methods: {
        getPrice(consumption) {
            if (this.item.config && this.item.config.pricePolicy) {
                if (this.item.config.pricePolicy == "PAYMENT_PER_CONSUMPTION") {
                    return Number.parseFloat(this.item.config.priceKwh * consumption).toFixed(2);
                }
                return Number.parseFloat(this.item.config.price * consumption).toFixed(2);
            }
            return 0;
        },
    },
};
</script>
